import { render, staticRenderFns } from "./VerticalIconMenu.vue?vue&type=template&id=140f77a8&scoped=true"
import script from "./VerticalIconMenu.vue?vue&type=script&lang=js"
export * from "./VerticalIconMenu.vue?vue&type=script&lang=js"
import style0 from "./VerticalIconMenu.vue?vue&type=style&index=0&id=140f77a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140f77a8",
  null
  
)

export default component.exports